export const isFeatureVisibleForCycle = (feature, productId, paymentCycle) => {
  var _feature$values, _feature$metadata;
  const isIncludedInPlan = ((_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null ? void 0 : _feature$values.available) ?? false;
  const isHiddenOnMonthly = paymentCycle === 'MONTHLY' && ((_feature$metadata = feature.metadata) == null ? void 0 : _feature$metadata.disabledInMonthlyCycle) === 'true';
  return isIncludedInPlan && !isHiddenOnMonthly;
};
//# sourceMappingURL=isFeatureVisibleForCycle.js.map